import { makeStyles } from '@material-ui/core/styles'

export const wikiSearchStyle = makeStyles(theme => ({
  root: {
    width: '100%',
    backgroundColor: theme.palette.secondary.main,
    paddingTop: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    borderBottom: 1,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.primary.main
  },
  closeButton: {
    position: 'absolute',
    color: theme.palette.geoColors.headerText.main,
    right: 4,
    top: -5,
    zIndex: 1000
  },
  closeButtonIcon: {
    color: theme.palette.primary.main,
    fontSize: '1.2rem'
  },
  searchField: {
    display: 'flex',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    borderRadius: 100,
    '& fieldset': {
      borderRadius: 5
    },
    '& .MuiInputLabel-outlined': {
      zIndex: 0
    }
  },
  triangle: {
    width: 0,
    height: 0,
    position: 'absolute',
    top: -10,
    right: 55,
    borderLeft: 10,
    borderLeftStyle: 'solid',
    borderLeftColor: 'transparent',
    borderRight: 10,
    borderRightStyle: 'solid',
    borderRightColor: 'transparent',
    borderBottom: 10,
    borderBottomStyle: 'solid',
    borderBottomColor: theme.palette.secondary.main
  }
}))
